export default "__VITE_ASSET__CZwHT7IW__"